import { Component, OnInit, Output, AfterViewInit, QueryList, ViewChildren, ViewChild, EventEmitter, ElementRef } from '@angular/core';
import { DataService } from 'app/services/data.service';
import { FrontEndService } from 'app/services/front-end.service';
import { StateService, Transition } from '@uirouter/angular';
import { XmppService } from "../../services/xmpp.service";
import { ChatService } from "app/services/chat.service";
import { LogService } from "app/services/log.service";
import { Observable } from "rxjs/Rx";

@Component({
    selector: 'app-project-chats-tab',
    templateUrl: './project-chats-tab.component.html',
    styleUrls: ['./project-chats-tab.component.scss']
})
export class ProjectChatsTabComponent implements OnInit, AfterViewInit {

    @ViewChild('chat_messages') private chat_messages_container: ElementRef;
    @ViewChildren('messages') messages: QueryList<any>;

    @Output() waitingEvent = new EventEmitter<string>();

    currentState: string;
    seleted_chat_room = "";
    selected_chat_user = "";
    // i am member will check if current user is a member
    // of this project. if this user is not a member then
    // he should not view the chats of this project.
    i_am_member = false;

    loading = false;
    project_details_flag = true;

    wait_timer = Observable.timer(0, 1000);
    wait_timer_subscription: any;

    search_string = "";

    chat_users = [];
    selected_project = "";


    project_status = "";
    project_active = true;
    project_owner = "";

    current_user_role = JSON.parse(localStorage.getItem('currentUserProfile')).role;
    current_username = JSON.parse(localStorage.getItem('currentUserProfile')).username;
    isProjectAccessible = false;

    constructor(
        public dataService: DataService,
        public front_end_service: FrontEndService,
        private stateService: StateService,
        public xmpp_service: XmppService,
        public chat_service: ChatService,
        private logService: LogService,
        private transition: Transition
    ) { }

    ngAfterViewInit() {
        this.messages.changes.subscribe(this.scrollToBottom);
    }

    wait_for_project_details(event) {
        const temp = this.dataService.get_array_details(
            this.dataService.project_list,
            "fip_id",
            this.dataService.selected_project
        );

        if (temp !== undefined) {
            if (temp['title'] !== undefined) {
                this.logService.printLog("Finally the project details are here");
                this.project_details_flag = false;
                this.loading = false;
                this.selected_project = temp;
                this.logService.printLog("selected_project" + JSON.stringify(this.selected_project));
                this.chat_users_list();

                this.wait_timer_subscription.unsubscribe();

                this.project_status = temp['status'];
                this.project_active = temp['isActive'];
                this.project_owner = temp['owner'].username;

                this.projectAccess();

            }
        }
    }

    /**
     * Chat Users Filter List
     */
    projectAccess() {
        // condition for show/hide projects
        let temp_flag = true;

        if(
            (this.project_status === 'CO' || this.project_active === false) &&
            (+this.current_user_role === 2 || +this.current_user_role === 3)
        ) {
            temp_flag = false;
        }
        if(
            (this.project_status === 'CO' || this.project_active === false) &&
            (this.project_owner !== this.current_username)
        ) {
            temp_flag = false;
        }
        if(+this.current_user_role === 0 || +this.current_user_role === 1 || +this.current_user_role === 4) {
            temp_flag = true;
        }

        this.isProjectAccessible = temp_flag;
    }

    ngOnInit() {
        this.waitingEvent.next("Waiting event");

        // make this check so that the chat server gives notifications.
        // when the chat will be opened then this value will be set.
        // in any case of state change or tab change this will be null.
        this.chat_service.selected_chat_room = "";

        this.wait_timer_subscription = this.wait_timer.subscribe(() => {
            if (this.project_details_flag) {
                this.wait_for_project_details("Local");
            }
        });

        if(this.transition.params().user_id != ""){
            this.openChat(this.transition.params().user_id);
        }
    }

    /**
     * Open chat tab
     * @param userId
     */
    openChat(userId) {
        this.selected_chat_user = userId;
        this.seleted_chat_room = this.chat_service.get_chat_room_name(userId);
        this.chat_service.selected_chat_room = this.chat_service.get_chat_room_name(userId);

        if (this.xmpp_service.groupMessages[this.seleted_chat_room]) {
            this.xmpp_service.message_received_notifier({
                "group_jid": this.seleted_chat_room,
                "read_count": this.xmpp_service.groupMessages[this.seleted_chat_room].length
            });
        }
    }

    chat_users_list() {
        this.chat_users = [];
        const assigneeType = ['patent_engineer', 'technical_expert', 'researcher', 'reviewer', 'legal_counsel', 'owner'];
        let arrayToSearch = [];
        let found;

        this.i_am_member = false;

        for (let j = 0; j < assigneeType.length; j++) {

            if(assigneeType[j] === 'owner') {
                arrayToSearch = [ this.selected_project[assigneeType[j]] ];
            } else {
                arrayToSearch = this.selected_project[assigneeType[j]];
            }

            for (let i = 0; i < arrayToSearch.length; i++) {

                found = false;

                for (let k = 0; k < this.chat_users.length; k++) {
                    if (this.chat_users[k].username === arrayToSearch[i].username) {
                        found = true;
                        break;
                    }
                }

                if (!found && arrayToSearch[i].id !== this.dataService.currentUser['id']) {
                    const obj1 = {};
                    obj1['title'] = arrayToSearch[i].title;
                    obj1['name'] = arrayToSearch[i].name;
                    obj1['full_name'] = arrayToSearch[i].title+arrayToSearch[i].name;
                    obj1['username'] = arrayToSearch[i].username;
                    obj1['id'] = arrayToSearch[i].id;
                    this.chat_users.push(obj1);
                }

                if(arrayToSearch[i].id === this.dataService.currentUser['id']) {
                    this.i_am_member = true;
                }
            }
            this.logService.printLog("chatUsers chatUsers - ", this.chat_users);
        }
    }

    /**
     * Chat Users Filter List
     * @param event
     */
    filter_chat_users(event) {
        this.logService.printLog("event " + event);
        this.logService.printLog("this.chat_users first " + JSON.stringify(this.chat_users));

        this.chat_users_list();

        if (this.search_string.trim() !== '') {
            this.chat_users = this.chat_users.filter((x) => {
                    for (const key in x) {
                        // look for the entry with a matching `code` value in arrays of objects
                        // in technical expert, patent engineer , researcher, reviwer and returning concern parent object
                        if (x[key] !== undefined && x[key] !== null) {
                            if (x[key].toString().toLowerCase().search(this.search_string.toString().toLowerCase()) !== -1) {
                                return x;
                            }
                        }
                    }
                }
            );
        }
    }

    send_message(message_input) {

        // check for empty string in input.
        if(message_input.value !== "") {

            this.xmpp_service.sendGroupMessage(
                this.seleted_chat_room,
                this.dataService.currentUser['id'],
                message_input.value,
            );

            message_input.value = "";
        }
    }

    scrollToBottom = () => {
        try {
            this.chat_messages_container.nativeElement.scrollTop = this.chat_messages_container.nativeElement.scrollHeight;
        } catch(err) { }
    };
}
